<div class="profile-content-section" data-cy="reputation-score-area">
  <h2 data-cy="reputation-score-title">Reputation Score</h2>

  <ng-container *ngIf="hasScore; else noReputationScore">
    <div class="reputation-score-container">
      <div class="flex flex-col justify-content-start align-items-start" style="gap: 40px;">
        <div data-cy="reputation-score-basis">
          Based on {{ firstName }}'s <strong>{{ completedProjectReviews }}</strong>
          completed project {{ completedProjectReviews === 1 ? 'review' : 'reviews' }}.
        </div>
        <div class="flex flex-row justify-content-center align-items-center" style="width: 100%;">
          <div style="width: 300px;">
            <ion-range class="reputation-score-range disabled" min="0" max="100" bar="grey" [value]="score"
              style="padding: 0; margin: 20px 0;"></ion-range>
            <div style="font-size: 20px; font-weight: bold; text-align: center; margin-top: 20px;" data-cy="reputation-score-value">{{ score }}%</div>
          </div>
        </div>
        <div class="ion-text-center" *ngIf="strongestMetrics" data-cy="reputation-score-strengths">
          {{ firstName }}'s strongest ratings are for {{ strongestMetrics }}.
        </div>
      </div>

      <div class="flex flex-col justify-content-start align-items-center" style="gap: 50px;" *ngIf="showRadar">
        <div class="radar-chart-wrapper">
          <div class="radar-chart">
            <div [id]="chartId" data-cy="kudos-radar-chart"></div>
          </div>
        </div>
        <div class="ion-text-center">
          Average rating (1-10) companies gave across the core completed project metrics.
        </div>
      </div>

      <ul class="rated-metrics" *ngIf="!showRadar && ratedMetrics.length" data-cy="reputation-score-ratings">
        <li *ngFor="let metric of ratedMetrics">{{ metric.label }}: {{ metric.value | number: '1.0-1' }} / 10</li>
      </ul>
    </div>
  </ng-container>

  <ng-template #noReputationScore>
    <div class="alert alert__warning text-center" data-cy="empty-reputation-score">
      No completed project reviews yet. The Reputation Score appears once a company rates {{ firstName }}'s work on a completed project.
    </div>
  </ng-template>
</div>
